import { Box, Skeleton, useMediaQuery } from "@mui/material";
import { SkeletonVideoItem } from "../SkeletonVideoItem/SkeletonVideoItem";
import getTheme from "../../../theme/theme";
import { PinnacleThemes } from "../../../theme/types";

export const SkeletonDashboard = () => {
    const theme = getTheme(PinnacleThemes.BASE_THEME);

    const isXs = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ mb: 4, width: '100%' }}>
            {/* Header skeleton */}
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    mb: 2,
                    gap: 1,
                    width: '100%',
                }}
            >
                <Skeleton
                    variant="circular"
                    width={isXs ? 30 : 40}
                    height={isXs ? 30 : 40}
                />
                <Skeleton
                    variant="circular"
                    width={isXs ? 30 : 40}
                    height={isXs ? 30 : 40}
                />
                <Skeleton
                    variant="text"
                    width={isXs ? 120 : 200}
                    height={isXs ? 30 : 40}
                />
                <Skeleton
                    variant="rectangular"
                    width={isXs ? 45 : 55}
                    height={isXs ? 20 : 25}
                    sx={{
                        borderRadius: 24,
                        ml: isXs ? 0 : 2,
                    }}
                />
            </Box>

            {/* Items skeleton */}
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    width: '100%',
                }}
            >
                {Array.from({ length: 8 }).map((__, vidx) => (
                    <Box
                        key={vidx}
                        sx={{
                            flex: {
                                xs: '0 0 calc(50% - 8px)',
                                sm: '0 0 calc(33.33% - 8px)',
                                md: '0 0 calc(25% - 8px)',
                                lg: '0 0 calc(20% - 8px)',
                            },
                            flexDirection: 'column',
                            minWidth: 0,
                        }}
                    >
                        <SkeletonVideoItem itemKey={vidx} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
